import { render, staticRenderFns } from "./out.vue?vue&type=template&id=23454b36&scoped=true&"
import script from "./out.vue?vue&type=script&lang=js&"
export * from "./out.vue?vue&type=script&lang=js&"
import style0 from "./out.vue?vue&type=style&index=0&id=23454b36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23454b36",
  null
  
)

export default component.exports